import { useEffect, useState } from "react";
import "./panel.css";
const Login = () => {
  const [username, setusername] = useState();
  const [password, setpassword] = useState();
  const [info, setinfo] = useState([]);
  const submite = () => {
    if (username == "youssef" && password == "123456789") {
      window.location.href = "/Panel";
    } else {
      alert("invalid email or passord");
    }
  };

  useEffect(() => {
    const info = { username: username, password: password };

    localStorage.setItem("infos", JSON.stringify(info));
  });
  return (
    <>
      <div class="logindiv">
        <h1>Login</h1>

        <label>
          <input
            type="email"
            id="email"
            placeholder="Email"
            required
            value={username}
            onChange={(e) => {
              setusername(e.target.value);
            }}
          />
        </label>
        <label>
          <input
            value={password}
            onChange={(e) => {
              setpassword(e.target.value);
            }}
            type="password"
            id="password"
            placeholder="Password"
            required
          />
        </label>
        <label>
          <input type="submit" id="submit" value="Login" onClick={submite} />
        </label>
      </div>{" "}
    </>
  );
};

export default Login;
